import { getAuthToken } from '@/lib/authentication'

const getDefaultHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': 'Bearer ' + getAuthToken()
})

export default getDefaultHeaders
